import axios from 'axios';
import { startCase } from 'lodash';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    take : 10,
    page : 0,
    skip : 0,
    columns: [],
    loaded : false,
    error : false,
    allLoaded : false,
    addNew : false,
    settings : {
        open : true,
        display: {
            status : {
                reservation : true,
                contract : true,
                release : true,
                shipping : true,
                invoice : true,
            },
            kooi_nr : true,
            order_nr : true,
            agent : true,
            customer : true,
            amount : true,
            changes : true,
        },
        colors: {
            in_progress : "bg-green-300",
            done : "bg-green-500",
            problem : "bg-yellow-300",
            warning : "bg-red-500",
            inactive : "bg-gray-300",
        }
    },
    filters : {
        agent_id : null,
        order : null,
        todo : "all",
    },
    pagination: {
        currentPage: 1,
        totalPageCount: 0,
        pagesize: 5
    },
    groups: null,
    meta : {},
    infinity : {
        active : false,
        columns: ["name", "iso_code", "symbol"],
    },
})

  // getters
  const getters = {
  }

  // actions
  const actions = {
    async load({commit, state, rootState}, page = 1){
        if(!state.allLoaded){
            commit("setLoaded", false);
            commit("skip", (page - 1) * state.take);

            return await axios.post(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/dashboard/overview", {page: state.page, skip :state.skip, take:state.take, filter : state.filters}).then((response) => {
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("additionaldata",_.get(response, "data.meta.groups", null));
                commit("set", response.data.data);
                commit("setError", false);
                commit("setLoaded", true);

            }).catch(function(error){
                commit("setError", true);
            })
        }
    }
  }

  // mutations
  const mutations = {
    additionaldata(state, data){
        state.groups = data;
    },
    clean(state){
        state.allLoaded = false;
        state.list = [];
        state.loaded = false;
        state.page = 0;
        state.filters = {
            agent_id : null,
            order : null,
            todo: "all",
        }
      },
      setError(state, status){
          state.error = status;
      },
      push(state, list){
          state.list.push(...list);
      },
      updateWithFilters(state, data){

        if(state.filters.order && state.filters.order.trim() != "" && data.order_no.toLowerCase().indexOf(state.filters.order) < 0) {
            return;
        }
        if(state.filters.agent_id && state.filters.agent_id != 0 && state.filters.agent_id != data.agent_id){
            return
        }
        var index = state.list.findIndex(item => item.id == data.id);
        if(data.kooi_status == "archived"){
            if(index <= -1){

            }else{
                state.list.splice(index, 1);
            }
        }else{
            if(data.action_step.includes(state.filters.todo)){
                if(index <= -1 ){
                    state.list.unshift(data);
                }else{
                    state.list[index] = data;
                }
            }
        }
      },
      updateKooi(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index <= -1){
            state.list.unshift(data);
        }else{
            state.list[index] = data;
        }
      },
      deleteKooi(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index <= -1){

        }else{
            state.list.splice(index, 1);
        }
      },
      setLoaded(state, status){
          state.loaded = status;
      },
      setAllLoaded(state, status){
        state.allLoaded = status;
      },
      increasePage(state){
          state.page++;
      },
      filters(state, data){
        state.filters = data;
      },
      pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        state.pagination.total = state.meta.total
        state.pagination.pagesize = state.meta.take

    },
    skip(state, skip) {
        state.skip = skip;
    },
    set(state, list){
        if(list == undefined || list.length <= 0){
            state.allLoaded = true;
        }
        if (state.infinity.active == true) {
            state.list.push(...list);
        } else {
            state.list = list;
        }
    },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
